import styled from 'styled-components'

export const StyledCameraScanner = styled.div`
  .webscanner-outer {
    position: unset;
  }

  .webscanner-logo,
  .webscanner-top-bar .webscanner-round-button:first-of-type {
    display: none;
  }

  .webscanner-top-bar {
    align-self: end;
  }

  /* Fullscreen styling for all browsers */
  &:fullscreen,
  &:-webkit-full-screen,
  &:-moz-full-screen,
  &:-ms-fullscreen {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 2147483647 !important;
    background: #000 !important;
    transform: translateZ(0) !important; /* Create new stacking context */

    .webscanner-outer {
      position: relative !important;
      width: 100% !important;
      height: 100% !important;
      z-index: 2147483647 !important;
    }
  }

  /* Fallback fullscreen class for manual fullscreen mode */
  &.fullscreen-fallback {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 2147483647 !important;
    background: #000 !important;
    transform: translateZ(0) !important;

    .webscanner-outer {
      position: relative !important;
      width: 100% !important;
      height: 100% !important;
      z-index: 2147483647 !important;
    }
  }
`
